import {
  pogToStudioItems,
  type StudioPogData,
} from "@CommonUtils/cdtStudio/adapters/pogToStudioItems";
import { fillSizeTiers, type SizeTierFill } from "../domain/sizeTiers";

export interface StudioItemsData extends StudioPogData {
  /** Which size tiers were filled at input, which stayed blank, and each tag's size span. */
  sizeTiers: Omit<SizeTierFill, "items">;
}

/** The shared adapter's reading, with a blank size tier filled where the tagged products around
 *  its pack size agree (see `fillSizeTiers`). */
export const studioItemsOf = (...args: Parameters<typeof pogToStudioItems>): StudioItemsData => {
  const data = pogToStudioItems(...args);
  const { items, ...sizeTiers } = fillSizeTiers(data.items);
  return { ...data, items, sizeTiers };
};
